module.exports = {
      id: "photostory-usage",
      viewBox: "0 0 50.625 54",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#photostory",
      toString: function () {
        return this.url;
      }
    }